export default (params) => ({
  trigger: {
    name: 'options_row.add_accessory_to_cart',
    params: params,
  },
  config: {
    schema: {
      primary_item_id: {
        type: 'integer',
      },
      attached_item_id: {
        type: 'integer',
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      sub_feature: {
        enum: [
          'employee_atc_page',
          'employee_ato_page',
          'customer_atc_page',
          'business_atc_page',
        ],
      },
    },
    event: {
      name: 'add_accessory_to_cart',
      params: {
        card_has_highlighted_segment: null,
      },
    },
    nonInt: false,
  },
});
